var map = {
	"./Fiber-Networks.jpg": 65810,
	"./Fiber-Networks.webp": 61707,
	"./General Contracting.jpg": 8612,
	"./Giza-ploice-staion.jpg": 56617,
	"./Software-Applications.avif": 87175,
	"./Software-Applications.jpg": 77653,
	"./Supply-Communication-Equipment-Electrical-Systems.jpg": 79791,
	"./card-bg-01.jpg": 1269,
	"./card-bg-02.png": 64471,
	"./general-supplies.jpg": 59747,
	"./logistic.jpg": 45283,
	"./old-Fiber-Networks.webp": 76447,
	"./old-General Contracting.jpg": 66434,
	"./old-Software-Applications-.avif": 77730,
	"./old-Software-Applications.jpg": 49827,
	"./old-Supply-Communication-Equipment-Electrical-Systems.jpg": 33851,
	"./old-general-supplies.png": 62868,
	"./old-logistic.jpg": 47716,
	"./services-section-01.png": 29358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91868;